import React from "react";
import { GroupedButtons } from "components";

import { FilterHeader } from "..";

const OptionsFilter = ({
  title = "",
  options = [],
  defaultOption = "",
  selectedOption,
  setFilter = () => { },
  requireSelection = false
}) => (
  <div className="filter-panel-filters-wrapper">
    <FilterHeader title={title} resetLabel="Reset" onReset={() => setFilter(defaultOption)} />
    <GroupedButtons
      options={options}
      selected={selectedOption ?? defaultOption}
      requireSelection={requireSelection}
      setFilter={setFilter}
    />
  </div>
);

export default OptionsFilter;
